export interface Address {
  line1: string;
  line2: string;
  city: string;
  state: string;
  zip: string;
  company: string;
}

export const EMPTY_ADDRESS = {
  line1: "",
  line2: "",
  city: "",
  state: "",
  zip: "",
  company: "",
};
